import * as React from 'react'

interface IProps {
  error?: Error
  resetError?: () => void
}

const Error: React.FunctionComponent<IProps> = ({ error, resetError }) => {
  return (
    <div className='alert alert-danger'>
      <h2>Er is iets misgegaan</h2>
      {error && <p>Foutmelding: {error.message}</p>}
      {resetError && (
        <button onClick={resetError} className='btn btn-primary'>
          Probeer opnieuw
        </button>
      )}
    </div>
  )
}

export default Error
